<template>
 <div>
      <el-upload
  class="avatar-uploader"
  :action="action"
  :show-file-list="false"
  :on-success="handleAvatarSuccess"
  :accept="accept"
  :style="cssVars"
 >
 <div v-if="imageUrl"  :class="showDelete?'hoverMaster':''"  @mouseenter="showcloseDelete" @mouseleave="hiddenDelete">
  <img  :src="imageUrl" class="avatar" v-if="type=='img'">
  <video v-else :src="imageUrl" class="avatar video-avatar vedio" controls ></video>
    <i class="el-icon-close close-icon"  v-if="showDelete" @click.stop="delect"></i>
    <i class=" el-icon-zoom-in zoom-icon"  v-if="showDelete" @click.stop="dialogVisible=true"></i>
   
 
 </div>
  
  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
</el-upload>
<el-dialog :visible.sync="dialogVisible">
  <img width="100%" :src="imageUrl" alt="" v-if="type=='img'">
  <video v-else :src="imageUrl"  controls ></video>
</el-dialog>  
 </div>
 

</template>
<script>
export default {
  props:{
    // 图片路径
    url:{type:String,default:null},
    // 可接受的格式 'image/png, image/jpeg,image/jpg' file vedio .mp4,/vedio/mp4
    accept: { type: String, default: 'image/png, image/jpeg,image/jpg' },
    // 接受这个参数后 返回可直接赋值给对象  obj={} obj[cateName]=data
    cateName: { type: String, default: '' },
    // 图片上传类型  img video
    type: { type: String, default: 'img' },
    // 针对table 编辑用
    index:{ type: [String,Number], default: 0},
    // 展示图片大小
    csssize:{ type: [String,Number], default: '148px'},
    // icon图标大小
    iconsize:{ type: [String,Number], default: '20px'},
    
   
  },
  computed: {
      
    
      cssVars(){
        return {"--csssize": this.csssize,"--iconsize":this.iconsize}
      },
      
    },
    data() {
      return {
        imageUrl: '',
        showDelete:true,
        dialogVisible:false,
        action:localStorage.getItem("upload"),
      };
    },
    watch:{
      url(){
        this.imageUrl = this.url
      }
      },
    methods: {
      handleAvatarSuccess(res, file) {
        console.log(res,file)
        this.imageUrl = res.data
      
          this.$emit('click', this.imageUrl, this.cateName,this.index )
      
       
      },
      showcloseDelete(){
   
        this.showDelete = true
      },
      hiddenDelete(){this.showDelete = false},
      delect(){
        this.imageUrl = ''
      
        this.$emit('click', this.imageUrl , this.cateName,this.index)
      }
    },
    created() {
      if(this.url){
        this.imageUrl = this.url
      }
    },
  }
</script>

<style scoped lang="scss">
  .avatar-uploader{
    display: inline-block !important;
    width: var(--csssize) !important;
    height: var(--csssize) !important;
  }
  .vedio{
    width: var(--csssize) !important;
    height: var(--csssize) !important;
  }
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    text-align: center;
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: var(--csssize);
    height: var(--csssize);
    line-height: var(--csssize);
    vertical-align: top;
  }
  .close-icon{
    position: absolute;
    right: 0;
    top: 0px;
    color: #fff;
    font-size: var(--iconsize);
    z-index: 10;
  }
  .zoom-icon{
    position: absolute;
    left:0px;
    top: 0px;
    color: #fff;
    font-size: var(--iconsize);
    z-index: 10;
  }
  .avatar {
    width: var(--csssize);
    height: var(--csssize);
    display: block;
  }
  .hoverMaster{
    position: relative;
  }
  .hoverMaster::after{
    width: 100%;
    height: 20%;
    background: rgba(0,0,0,0.5);
    
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    content: '';
  }
</style>